import React, { useState } from 'react';
import NavBar from './components/NavBar';
import ChatWidget from './components/ChatWidget';
import GlobalHomePage from './pages/GlobalHomePage';
import CVPage         from './pages/CVPage';
import ProjectsPage   from './pages/ProjectsPage';
import EconomicPage from './pages/EconomicPage';
import StockIndexPage from './pages/StockIndexPage';
import MetroLanding   from './pages/MetroLandingPage';
import MetroPage      from './pages/MetroPage';
import WebScraperPage from './pages/WebScraperPage';
import InsightBotPage from './pages/InsightBotPage';
import GeospatialPage from './pages/GeospatialPage';
import UnderConstructionPage from './pages/UnderConstructionPage';
import GraphViewer from './pages/GraphViewer';
import ContactPage from './pages/ContactPage';
import TopicBotPage from './pages/TopicBotPage';

export default function App() {
  const [section, setSection] = useState(null);
  const [dataset, setDataset] = useState(null);
  const [symbol, setSymbol] = useState(null);

  // Handler for homepage card navigation
  const handleHomeCardNavigate = (target) => {
    setSection(target);
  };

  // always show NavBar, then the page below it
  return (
    <>
      {/* Add NavBar to all pages */}
      <NavBar onNavigate={setSection} section={section} />

      {/* Add ChatWidget to all pages */}
      <div style={{ color: 'black' }}>
        <ChatWidget />
      </div>


      {/* Define section routing */}
      {section === null && (
        <GlobalHomePage onCardNavigate={handleHomeCardNavigate} />
      )}

      {section === 'cv' && (
        <CVPage onBack={() => setSection(null)} />
      )}

      {section === 'contact' && (
        <ContactPage onBack={() => setSection(null)} />
      )}

      {section === 'projects' && (
        <ProjectsPage onNavigate={setSection} onBack={() => setSection(null)} />
      )}

      {section === 'metro' && (
        dataset === null
          ? <MetroLanding onSelect={setDataset} onBack={() => setSection('projects')} />
          : <MetroPage dataset={dataset} onBack={() => setDataset(null)} />
      )}

      {section === 'webscraper' && (
        <WebScraperPage onBack={() => setSection('projects')} />
      )}

      {section === 'economic' && (
        <EconomicPage onNavigate={setSection} onBack={() => setSection('projects')} />
      )}

      {section === 'stock' && (
        <StockIndexPage
          onBack={() => setSection('economic')}
          onNavigate={({ section: newSection, symbol }) => {
            setSection(newSection);
            setSymbol(symbol);
          }}
        />
      )}

      {(section === 'graph') && (
        <GraphViewer symbol={symbol} onBack={() => setSection('stock')} />
      )}

      {(section === 'geospatial') && (
        <GeospatialPage onBack={() => setSection('projects')} />
      )}

      {(section === 'insightbot') && (
        <InsightBotPage onBack={() => setSection('projects')} />
      )}

      {(section === 'topicbot') && (
        <TopicBotPage onBack={() => setSection('projects')} />
      )}

      {section === 'next' && (
        <UnderConstructionPage onBack={() => setSection('economic')} />
      )}
    </>
  );
}